import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ height: "100vh", padding: "20px" }}
        >
          <h2 className="text-danger mb-3">Something went wrong!</h2>
          <details
            className="mb-3"
            style={{ whiteSpace: "pre-wrap", maxWidth: "800px" }}
          >
            <summary className="btn btn-primary mb-2">
              Click to see error details
            </summary>
            <div className="alert alert-danger mt-2">
              <h5>Error:</h5>
              <pre>{this.state.error && this.state.error.toString()}</pre>
              <h5 className="mt-3">Component Stack:</h5>
              <pre>{this.state.errorInfo.componentStack}</pre>
            </div>
          </details>
          <button
            className="btn btn-secondary"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
